export enum LinkedinSubTypeEnum {
    REPOST = 'REPOST',
    POST = 'POST'
}
